/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from "react";
import { use100vh } from 'react-div-100vh'
import { isMobile } from "react-device-detect";
import Column from "./Column";
import Row from "./Row";
import { Dialog } from '@mui/material';
import Modal from "./Modal";

function Profile(props: any) {
  const {
      hellDucks,
      keys,
      loadingHell,
      loadingKeys,
      setHellducks,
      setKeys
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSecondduck, setselectedSecondduck] = useState<any>(undefined);
  const [selectedDemon, setSelectedDemon] = useState<any>(undefined);
  const [selectedHellduck, setSelectedHellduck] = useState<any>(undefined);
  const height = use100vh()
  const currentHeight = height ? height * 1.2 : '120vh';

  const modalProps = {
    style: {
        borderRadius: 18,
        background: 'rgba(29, 31, 32, 0.50)',
        
    },
  };

  const handleModal = () => {
    if ((selectedSecondduck && selectedHellduck && selectedDemon))
    {
      setIsOpen(true);
    }
  }

  return (
    <div style={{ height: isMobile ? currentHeight : '100%' }} className={`relative flex flex-col md:flex-row items-center justify-between w-full rounded-3xl content h-5/6`}>
      <Column
          ducks={hellDucks}
          handleSelection={setSelectedHellduck}
          current={selectedHellduck}
          otherSideCurrent={selectedDemon}
          loading={loadingHell}
          text="The Duck you'll burn"
      />
      <div className="flex flex-col h-full justify-between items-center w-full md:w-6/12">
        <button onClick={handleModal} className={`flex ${ (selectedSecondduck && selectedHellduck && selectedDemon) ? 'active-bg' : 'og-bg-opacity-black'} rounded-lg h-fit px-16 py-4 m-auto my-3`}>
          <div className={`m-auto leading-normal uppercase ${ (selectedSecondduck && selectedHellduck && selectedDemon) ? 'txt-white' : 'txt-white'} text-4xl md:text-2xl`}>
            SEND
          </div>
        </button>
        <Row
            ducks={keys.filter((duck:any) => !duck.traits.find((element:any) => element.trait_type === 'Portal Availability'))}
            handleSelection={setselectedSecondduck}
            current={selectedSecondduck}
            loading={loadingKeys}
        />
      </div>
      <Column
          ducks={hellDucks}
          handleSelection={setSelectedDemon}
          current={selectedDemon}
          otherSideCurrent={selectedHellduck}
          loading={loadingHell}
          text="The Duck you'll change"
      />
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} PaperProps={modalProps} fullWidth={true}
        maxWidth={isMobile? 'xl' : 'md'}>
        <Modal
          selectedHellduck={selectedHellduck}
          selectedDemon={selectedDemon}
          selectedSecondduck={selectedSecondduck}
          hellducks={hellDucks}
          secondDucks={keys}
          setHellducks={setHellducks}
          setSecondDucks={setKeys}
        />
      </Dialog>
    </div>
  )
}

export default Profile;